export const entityName = 'dataStoreAgents';
export const idAttribute = 'agentId';
